var App = App || {};

App.BlockCategory = (function () {
    'use strict';

    /* ==========================================================================
    Public API
    ========================================================================== */

    function initializeCategoryCompare(categoryCompareId) {

        // Initialize the category compare UI component for the given ID.
        // Sets up event binding and initial state for compare controls.
        const categoryCompareElement = document.getElementById(categoryCompareId);
        if (!categoryCompareElement) return;

        const compareControlsElement = categoryCompareElement.querySelector(".block-category-compare-controls");
        if (!compareControlsElement) return;

        bindCompareCheckboxEvents(categoryCompareElement, compareControlsElement);
        bindBreakpointChangeEvents(categoryCompareElement, compareControlsElement);
        setInitialCheckboxState(categoryCompareElement, compareControlsElement);
    }

    /* ==========================================================================
    Event Binding
    ========================================================================== */

    const bindCompareCheckboxEvents = (categoryCompareElement, compareControlsElement) => {
        
        // Bind change events to all compare checkboxes to update UI on selection.
        const checkboxElements = compareControlsElement.querySelectorAll(".form-check-input");
        
        for (const checkboxElement of checkboxElements) {
            checkboxElement.addEventListener("change", () => {
                updateCompareUI(categoryCompareElement, compareControlsElement);
            });
        }
    };

    const bindBreakpointChangeEvents = (categoryCompareElement, compareControlsElement) => {

        // Bind breakpoint change events to reset checkbox state responsively.
        const onBreakpointEnter = (event) => {

            setInitialCheckboxState(
                categoryCompareElement,
                compareControlsElement
            );
        };

        ["enter-xs", "enter-sm", "enter-md", "enter-lg", "enter-xl", "enter-xxl"].forEach(bp => {
            document.addEventListener(bp, onBreakpointEnter);
        });
    };

    /* ==========================================================================
    State Initialization
    ========================================================================== */

    const setInitialCheckboxState = (categoryCompareElement, compareControlsElement) => {
        
        // Set initial checked/disabled state for compare checkboxes based on breakpoint limits.
        const checkboxElements = compareControlsElement.querySelectorAll(".form-check-input");
        const selectionLimits = getCompareSelectionLimits();
        
        // Reset checkboxes
        for (const checkboxElement of checkboxElements) {
            checkboxElement.checked = false;
            checkboxElement.disabled = false;
        }

        // Check first N allowed by breakpoint using index-based loop
        for (let i = 0; i < selectionLimits.max && i < checkboxElements.length; i++) {
            checkboxElements[i].checked = true;
        }

        // Show or hide control panel
        compareControlsElement.style.display = checkboxElements.length <= selectionLimits.max ? "none" : "";

        updateCompareUI(categoryCompareElement, compareControlsElement, selectionLimits);
    };

    /* ==========================================================================
    Helpers
    ========================================================================== */

    const countCheckedCheckboxes = checkboxElements => {
        
        // Count checked checkboxes and collect their IDs for UI sync.
        let checkedCount = 0;
        const activeCheckboxIds = [];
        
        for (const checkboxElement of checkboxElements) {
            if (checkboxElement.checked) {
                checkedCount++;
                activeCheckboxIds.push(checkboxElement.id);
            }
        }
        return { checkedCount, activeCheckboxIds };
    };

    /* ==========================================================================
    UI Synchronization
    ========================================================================== */

    const updateCompareUI = (categoryCompareElement, compareControlsElement, selectionLimits) => {
        
        // Synchronize UI: enforce min/max limits and show/hide controlled columns.
        const checkboxElements = compareControlsElement.querySelectorAll("input[type='checkbox']");
        selectionLimits = selectionLimits || getCompareSelectionLimits();
        
        const checkedInfo = countCheckedCheckboxes(checkboxElements);
        const checkedCount = checkedInfo.checkedCount;
        const activeCheckboxIds = checkedInfo.activeCheckboxIds;
        
        // Enforce min/max limits
        for (const checkboxElement of checkboxElements) {
            if (checkboxElement.checked) {
                checkboxElement.disabled = checkedCount <= selectionLimits.min;
            } 
            else {
                checkboxElement.disabled = checkedCount >= selectionLimits.max;
            }
        }

        // Update controlled columns
        const controlledColumnElements = categoryCompareElement.querySelectorAll("[data-controlledby]");
        for (const element of controlledColumnElements) {
            const controllingId = element.getAttribute("data-controlledby");
            element.style.display = activeCheckboxIds.indexOf(controllingId) !== -1 ? "" : "none";
        }
    };

    /* ==========================================================================
    Breakpoint Rules
    ========================================================================== */

    const getCompareSelectionLimits = () => {
        
        // Get min/max selection limits based on current breakpoint.
        switch (App.ZagBreakpoints.getBreakpoint()) {
            case 'xxl':
            case 'xl': return { max: 4, min: 2 };
            case 'lg':
            case 'md': return { max: 3, min: 2 };
            default: return { max: 2, min: 1 };
        }
    };

    /* ==========================================================================
    Public API Exposure
    ========================================================================== */

    return {
        initializeCategoryCompare
    };

})();